<template>
    <div class="public_container add_approval_wrap" v-loading="loading">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"></ReturnNavBar>
        </div>
        <div class="mobile_container">
            移动端审批详情
        </div>
        <div class="add_footer_wrap">

        </div>
    </div>
</template>

<script>
import {} from "@/api";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
export default {
    name: "approvalDetail",
    components: {ReturnNavBar},
    data() {
        return {
            loading:false
        };
    },
    created() {
        this.approval_id = this.$route.query.approval_id
    },
    methods: {
        handleClose() {
            this.$emit('close',{id:this.approval_id});
            this.visible = false;
        },
        handleConfirm() {
            this.$emit('confirm',{id:this.approval_id});
            this.handleClose();
        },
    },
};
</script>

<style lang="scss" scoped>

</style>
